<template>
  <div class="commission-wrap">
    <ul class="breadcrumb">
      <li>
        <router-link :to="{name: 'Home'}"><i class="el-icon-s-home"></i>Home</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Dashboard'}"><i class="el-icon-s-grid"></i>Dashboard</router-link>
      </li>
      <li>
        <span>Commission</span>
      </li>
    </ul>
    <div class="commission-box">
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Referral Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComRefU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComRefA }}</span><span class="text">ALEO</span></div>
        </div>
        <div class="item-footer">
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
          <!-- <p><span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Rank Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComBrandU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComBrandA }}</span><span class="text">ALEO</span></div>
        </div>
        <div class="item-footer">
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
          <!-- <p><span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/mining.png" alt="mining">Mining Token</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ miningOverview.aleo || 0 }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/iron.png" alt="IRON"><span class="number">{{ miningOverview.iron || 0 }}</span><span class="text">IRON</span></div>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/hourglass.png" alt="hourglass">Next Daily Commission</h4>
        </div>
        <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
        <div class="item-body mt-3">
          <!-- <p class="text-tip">After <span class="number-time">06</span>hours : <span class="number-time">54</span>mins : <span class="number-time">42</span>seconds</p> -->
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ commissionEstimation.usdt }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ commissionEstimation.aleo }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/iron.png" alt="IRON"><span class="number">{{ commissionEstimation.iron }}</span><span class="text">IRON</span></div>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/reward.png" alt="hourglass">Maxout</h4>
        </div>
        <div class="item-body">
          <p>Total Invest: {{ userMaxout.beautyTotalInvest }} USDT</p>
          <p>Total Commission: {{ userMaxout.beautyTotalCom }} USDT</p>
          <p>Maxout: {{ userMaxout.beautyMaxout }} USDT</p>
          <div class="range" :style="`--p:${userMaxout.percentView}`"></div>
          <div class="item-tip">
            <i class="el-icon-info"></i>
            <em>Maxout commission you get upto 400% of your investment.</em>
          </div>
        </div>
      </div>
    </div>
    <div class="history-section" :class="{ 'loading': isLoadingHistory }">
      <div class="table-box">
        <h4 class="title">History</h4>
        <div class="controls">
          <el-button :class="{'active': currentTab ===  1}" @click="showTab(1)">Mining</el-button>
          <el-button :class="{'active': currentTab ===  2}" @click="showTab(2)">USDT Referral</el-button>
          <el-button :class="{'active': currentTab ===  3}" @click="showTab(3)">ALEO Referral</el-button>
          <el-button :class="{'active': currentTab ===  4}" @click="showTab(4)">USDT Rank</el-button>
          <el-button :class="{'active': currentTab ===  5}" @click="showTab(5)">ALEO Rank</el-button>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <template v-if="currentTab === 1">
              <dl class="table-small2">
                <dt>
                  <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                  <div>{{ $t('TEXT_AMOUNT') }}</div>
                  <div>Rate</div>
                  <div>{{ $t('TEXT_AMOUNT_COMMISSION') }}</div>
                  <div>{{ $t('TEXT_TOTAL_BUY') }}</div>
                  <div class="flex-1">{{ $t('TEXT_DATE') }}</div>
                </dt>
                <template v-if="commissionAleoHistory.length">
                  <dd v-for="(history, index) in commissionAleoHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.beautyAmount }}</div>
                    <div>{{ history.rate }}</div>
                    <div>{{ history.beautyAmount }}</div>
                    <div>{{ history.beautyTotalBuy }}</div>
                    <div class="flex-1">{{ history.beautyCreatedAt }}</div>
                  </dd>
                </template>
                <template v-else>
                  <dd class="no-data-wrap">
                    <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                  </dd>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
            <template v-if="currentTab === 2 || currentTab === 3">
              <dl class="table-medium">
                <dt>
                  <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                  <div>{{ $t('TEXT_USERNAME') }}</div>
                  <div>{{ $t('TEXT_AMOUNT') }}</div>
                  <div>%</div>
                  <div class="width-1_5x">{{ $t('TEXT_AMOUNT_COMMISSION') }}</div>
                  <div>{{ $t('TEXT_LEVEL') }}</div>
                  <div>{{ $t('TEXT_SYMBOL') }}</div>
                  <div class="flex-1">{{ $t('TEXT_DATE') }}</div>
                </dt>
                <template v-if="commissionHistory.length">
                  <dd v-for="(history, index) in commissionHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.fromUser }}</div>
                    <div>{{ history.beautyFromAmount }}</div>
                    <div>{{ (history.percent * 100).toFixed(0) }}</div>
                    <div class="width-1_5x">{{ history.beautyAmount }}</div>
                    <div>F{{ history.level }}</div>
                    <div>{{ history.symbol }}</div>
                    <div class="flex-1">{{ history.beautyCreatedAt }}</div>
                  </dd>
                </template>
                <template v-else class="no-data-wrap">
                  <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
            <template v-if="currentTab === 4 || currentTab === 5">
              <dl class="table-medium">
                <dt>
                  <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                  <div>{{ $t('TEXT_USERNAME') }}</div>
                  <div>{{ $t('TEXT_AMOUNT') }}</div>
                  <div>%</div>
                  <div>{{ $t('TEXT_AMOUNT_COMMISSION') }}</div>
                  <div>{{ $t('TEXT_LEVEL') }}</div>
                  <div>{{ $t('TEXT_SYMBOL') }}</div>
                  <div class="flex-1">{{ $t('TEXT_DATE') }}</div>
                </dt>
                <template v-if="commissionBrandHistory.length">
                  <dd v-for="(history, index) in commissionBrandHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.fromUser }}</div>
                    <div>{{ history.beautyFromAmount }}</div>
                    <div>{{ (history.percent * 100).toFixed(0) }}</div>
                    <div>{{ history.beautyAmount }}</div>
                    <div>{{ history.role }}</div>
                    <div>{{ history.symbol }}</div>
                    <div class="flex-1">{{ history.beautyCreatedAt }}</div>
                  </dd>
                </template>
                <template v-else class="no-data-wrap">
                  <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlipCountdown from 'vue2-flip-countdown'
export default {
  components: {
    FlipCountdown
  },
  data () {
    return {
      deadline: null,
      currentTab: 1,
      isLoadingHistory: false,
      miningOverview: {}
    }
  },
  computed: {
    userOverview () {
      return this.$store.getters.userOverview
    },
    userMaxout () {
      return this.$store.getters.userMaxout
    },
    pagination () {
      return this.$store.getters.pagination
    },
    commissionHistory () {
      return this.$store.getters.commissionHistory
    },
    commissionAleoHistory () {
      return this.$store.getters.commissionAleoHistory
    },
    commissionBrandHistory () {
      return this.$store.getters.commissionBrandHistory
    },
    commissionEstimation () {
      return this.$store.getters.commissionEstimation
    }
  },
  async created () {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    date.setUTCHours(0)
    date.setUTCMinutes(0)
    date.setUTCSeconds(0)
    this.deadline = date.toUTCString()

    await this.getHistory()
    this.$store.dispatch('getUserMaxout').then(rs => {})
    this.$store.dispatch('getCommissionEstimation')
  },
  methods: {
    showTab (tab) {
      this.currentTab = tab
      this.getHistory()
    },
    async getHistory (page = 1) {
      this.isLoadingHistory = true
      switch (this.currentTab) {
        case 1:
          await this.$store.dispatch('getCommissionAleoHistory', page)
          break
        case 2:
          await this.$store.dispatch('getCommissionRefHistory', { page, symbol: 'usdt' })
          break
        case 3:
          await this.$store.dispatch('getCommissionRefHistory', { page, symbol: 'aleo' })
          break
        case 4:
          await this.$store.dispatch('getCommissionBrandHistory', { page, symbol: 'usdt' })
          break
        case 5:
          await this.$store.dispatch('getCommissionBrandHistory', { page, symbol: 'aleo' })
          break
      }
      setTimeout(() => {
        this.isLoadingHistory = false
      }, 300)
    },
    goToHistory () {
      this.$router.push({ name: 'Commission' })
    },
    goToPage (page) {
      const temp = JSON.parse(JSON.stringify(this.pagination))
      temp.page = page
      this.$store.dispatch('setPagination', temp)
      this.getHistory(page)
    }
  }
}
</script>
